import { useField } from "formik";
import { FormField } from "@/components/common/form-field";

const FIELD_LABEL = "text-muted-foreground text-xs font-semibold uppercase tracking-wide";

/**
 * A Formik-bound money input. Stores the raw **dollar string** in Formik (e.g.
 * "1234.56"); the autosave/payload layer converts to integer cents. Restricts
 * input to a decimal amount. A `$` sits inside the field.
 */
export function MoneyField({
  name,
  label,
  className,
}: {
  name: string;
  label: string;
  className?: string;
}) {
  const [, , helpers] = useField<string>(name);
  return (
    <FormField
      name={name}
      label={label}
      labelClassName={FIELD_LABEL}
      className={className}
      inputMode="decimal"
      placeholder="0.00"
      icon={<span className="text-muted-foreground text-sm">$</span>}
      onChange={(e) => {
        const raw = e.target.value;
        // Allow only digits + one decimal point, max 2 decimals.
        if (raw === "" || /^\d*\.?\d{0,2}$/.test(raw)) helpers.setValue(raw);
      }}
    />
  );
}
